import { isSilentLogin, isFromMobile } from "./embedMode";

// visible bottom (px from the viewport top) of the fixed app header: its white rounded bar reaches below the
// <header> box itself. Sticky bars sit right under it (Equipment Diagnosis / Previous Evaluation unit chips).
export function appHeaderBottom(fallback = 50) {
  const header = document.querySelector("header.mainHeader");
  // silent login / the mobile app webview render no header: the bars stick to the very top
  if (!header) return isSilentLogin() || isFromMobile({ query: Object.fromEntries(new URLSearchParams(location.search)) }) ? 0 : fallback;
  const bottom = Math.max(header.getBoundingClientRect().bottom, ...[...header.children].map(c => c.getBoundingClientRect().bottom));
  return bottom > 0 ? Math.round(bottom) : fallback;
}
